import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgFiles} from "~/assets/svg/files.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmFilesIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgFiles id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
